import React, { useEffect } from "react";
import { FiBriefcase, FiPlus } from "react-icons/fi";
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../redux/actions/CartActions";
import "./styles/options.css";

const OHADA_COUNTRIES = [
  "BJ",
  "BF",
  "CM",
  "CF",
  "KM",
  "CG",
  "CD",
  "CI",
  "GQ",
  "GA",
  "GN",
  "GW",
  "ML",
  "NE",
  "SN",
  "TD",
  "TG",
];

const SERVICE_NAMES = {
  management: "Gestion 360°",
  admin: "Administration d'entreprise",
  juridique: "Suivi juridique",
  sales: "Relation client",
  grh: "Ressources humaines",
};

function Companies() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentStep = "Entreprise";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const cart = useSelector((state) => state.cart);
  const { userCompanies } = useSelector((state) => state.companies);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleAddToCart = async (value) => {
    await dispatch(addToCart({ company: value }));

    const from = cart?.from;
    const countryCode = value.country.toUpperCase();

    // Redirection si pays OHADA + origine domiciliation
    if (from === "domiciliation" && OHADA_COUNTRIES.includes(countryCode)) {
      return navigate("/domiciliation");
    }

    // Redirections selon la source
    switch (from) {
      case "management":
        return navigate("/platform-gest");
      case "admin":
        return navigate("/platform-admin");
      default:
        return navigate("/platform-juridique");
    }
  };

  const handleSkipClick = () => {
    navigate(`/business-country`);
  };

  const filteredCompanies = userCompanies.filter((company) => {
    // If the selected service is "admin", only include companies based in Cameroon (CM)
    if (cart.from === "admin") {
      return company.country === "CM";
    }

    // If the selected service is "domiciliation", only include companies from OHADA countries
    if (cart.from === "domiciliation") {
      return OHADA_COUNTRIES.includes(company.country);
    }

    return true;
  });

  const serviceName = SERVICE_NAMES[cart.from];

  return (
    <div className="options-page companies-page">
      <Header />
      <ProgressBar steps={steps} currentStep={currentStep} />

      <div className="container options-container">
        <header className="options-header">
          <h1 className="options-title">
            {cart.from === "domiciliation" ? (
              <>
                Quelle <span>entreprise</span> souhaitez-vous domicilier chez
                nous ?
              </>
            ) : (
              <>
                Pour quelle <span>entreprise</span> souhaitez-vous souscrire
                {serviceName ? ` au service ${serviceName}` : ""} ?
              </>
            )}
          </h1>
          <p className="options-lead">
            Choisissez l'une de vos entreprises ou enregistrez-en une autre.
          </p>
        </header>

        <div className="company-grid">
          {filteredCompanies.map((company) => (
            <button
              key={company._id}
              type="button"
              className={`company-card ${
                cart?.company?._id === company._id ? "is-selected" : ""
              }`}
              onClick={() => handleAddToCart(company)}
            >
              <span className="option-icon" aria-hidden="true">
                <FiBriefcase />
              </span>
              <span className="company-card-text">
                <strong>{company.businessName}</strong>
                <span>
                  {[company.businessType, company.country]
                    .filter(Boolean)
                    .join(" · ")}
                </span>
              </span>
            </button>
          ))}

          <button
            type="button"
            className="company-card is-new"
            onClick={handleSkipClick}
          >
            <span className="option-icon" aria-hidden="true">
              <FiPlus />
            </span>
            <span className="company-card-text">
              <strong>Autre entreprise</strong>
              <span>Enregistrer une entreprise existante</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Companies;
